import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/makeRequest.js';

// Async thunks
export const fetchUserInvoices = createAsyncThunk(
    'invoices/fetchUserInvoices',
    async (_, { rejectWithValue }) => {
        try {
            const response = await get('/payment/invoices');
            console.log(response, "response")
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch invoices');
        }
    }
);

export const downloadInvoice = createAsyncThunk(
    'invoices/downloadInvoice',
    async (invoiceId, { rejectWithValue }) => {
        try {
            const response = await get(`/payment/invoices/${invoiceId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to download invoice');
        }
    }
);

const invoiceSlice = createSlice({
    name: 'invoices',
    initialState: {
        invoices: [],
        loading: false,
        error: null,
        downloadLoading: false,
        downloadError: null
    },
    reducers: {
        clearErrors: (state) => {
            state.error = null;
            state.downloadError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch invoices
            .addCase(fetchUserInvoices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserInvoices.fulfilled, (state, action) => {
                state.loading = false;
                state.invoices = action.payload;
            })
            .addCase(fetchUserInvoices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Download invoice
            .addCase(downloadInvoice.pending, (state) => {
                state.downloadLoading = true;
                state.downloadError = null;
            })
            .addCase(downloadInvoice.fulfilled, (state) => {
                state.downloadLoading = false;
            })
            .addCase(downloadInvoice.rejected, (state, action) => {
                state.downloadLoading = false;
                state.downloadError = action.payload;
            });
    }
});

export const { clearErrors } = invoiceSlice.actions;
export default invoiceSlice.reducer;